var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#667085;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.5,24.8v24H22.4v-24H41.5z M37.9,10.4H26l-2.4,2.4h-8.4v4.8h33.6v-4.8h-8.4L37.9,10.4z M46.2,20.1H17.6v28.8 c0,2.7,2.1,4.8,4.8,4.8h19.2c2.7,0,4.8-2.1,4.8-4.8V20.1H46.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteReport);
export default __webpack_public_path__ + "static/media/delete-report.464d05a7aa6cff80ac18a094dbd75b53.svg";
export { ForwardRef as ReactComponent };